import { ILiveUpdateGroupConfiguration } from '@tc/live-updates';
import { IDropCatchConfiguration } from './IDropCatchConfiguration';

export class DefaultConfiguration implements IDropCatchConfiguration {
  production: boolean;
  applicationName: string;
  configurationName: string;
  apiUrl: string;
  refreshRate: number;
  client_id: string;
  paypalEnvironment: string;
  pageSizeOptions: number[];
  googleTagManagerId: string;
  launchDarklyKey: string;
  reloadDelayInMinutes: number;
  authorizeEndpoint: string;
  logOutEndpoint: string;
  refreshTokenEndpoint: string;
  refreshTokenLifeTime: number;
  verifySessionActiveMs: number;
  accessTokenName: string;
  tokenDomain: string;
  whiteList?: string[];
  isApiLoggingEnabled: boolean;
  isConsoleLoggingEnabled: boolean;
  logApiUrl?: string;
  logEndpoint: string;
  logLevel: number;
  translatorApiUrl: string;
  getTranslationsEndpoint: string;
  getTranslatorTranslationsEndpoint: string;
  upsertTranslationEndpoint: string;
  getLanguagesEndpoint: string;
  getTranslatorLanguagesEndpoint: string;
  updateMissingTranslationEndpoint: string;
  getTranslationEndpoint: string;
  getTranslatorTranslationEndpoint: string;
  liveUpdateGroupConfigurations: ILiveUpdateGroupConfiguration[];
  featureFlags: {
    globalErrorHandling: boolean;
  };
  captchaCloudApiUrl: string;
  captchaEndpoint: string;
  captchaKeyId: string;
  premiumAuctionBannerThreshold: number;
  premiumAuctionBidThreshold: number;
  myNameBrightUrl: string;

  constructor() {
    this.setStagingConfiguration();
  }

  private setStagingConfiguration(): void {
    this.production = false;
    this.applicationName = 'DropCatch';
    this.configurationName = 'Default';

    this.apiUrl = 'https://stgclient.dropcatch.com';
    //this.apiUrl = 'http://localhost:5380';
    this.refreshRate = 5000;
    this.client_id = 'DropCatch';
    this.paypalEnvironment = 'sandbox';
    this.pageSizeOptions = [50, 100, 200, 250];
    this.googleTagManagerId = 'GTM-P4LTMZD';
    this.launchDarklyKey = '';
    this.reloadDelayInMinutes = 5;
    this.authorizeEndpoint = '/Authorize';
    this.logOutEndpoint = '/Logoff';
    this.refreshTokenEndpoint = '/refreshtoken';
    this.refreshTokenLifeTime = 86_400_000; // 24 hours
    this.verifySessionActiveMs = 86_400_000; // 24 hours - effectively disable for local dev
    this.accessTokenName = 'DropCatch';
    this.tokenDomain = 'localhost';
    this.whiteList = ['https://dropcatch-downloads.s3.amazonaws.com'];
    this.logApiUrl = 'https://stguilogging.tcdevops.com';
    this.logEndpoint = 'CreateUiLogEvent';
    this.logLevel = 3;
    this.isApiLoggingEnabled = false;
    this.isConsoleLoggingEnabled = true;
    this.translatorApiUrl = 'https://stgtranslate.dropcatch.com';
    this.getTranslationsEndpoint = 'GetTranslations';
    this.getTranslatorTranslationsEndpoint = 'Translator/GetTranslations';
    this.upsertTranslationEndpoint = 'UpsertTranslations';
    this.getLanguagesEndpoint = 'GetLanguages';
    this.getTranslatorLanguagesEndpoint = 'Translator/GetLanguages';
    this.updateMissingTranslationEndpoint = 'MissingTranslation';
    this.getTranslationEndpoint = 'GetTranslation';
    this.getTranslatorTranslationEndpoint = 'Translator/GetTranslation';
    this.liveUpdateGroupConfigurations = [
      {
        groupName: 'dropcatch',
        apiUrl: 'https://stgrt.dropcatch.com',
        hubConfigurations: [
          {
            endpoint: 'cart',
            method: 'Cart',
            requiresAuthentication: true,
            configurationName: 'cart'
          },
          {
            endpoint: 'auction',
            method: 'domain_bid',
            requiresAuthentication: false,
            configurationName: 'domain'
          },
          {
            endpoint: 'account',
            method: 'AccountInfoRefreshed',
            requiresAuthentication: true,
            configurationName: 'account'
          }
        ]
      },
      {
        groupName: 'permission',
        apiUrl: 'https://stgrt.dropcatch.com',
        hubConfigurations: [
          {
            endpoint: 'permission',
            method: 'permissions',
            requiresAuthentication: true,
            configurationName: 'permissions'
          }
        ]
      },
      {
        groupName: 'translation',
        apiUrl: 'https://stgtranslate.dropcatch.com',
        hubConfigurations: [
          {
            endpoint: 'translation',
            method: 'updateTranslation',
            requiresAuthentication: false,
            configurationName: 'translation'
          }
        ]
      }
    ];
    this.featureFlags = {
      globalErrorHandling: true
    };
    this.captchaCloudApiUrl = 'https://www.google.com/recaptcha/enterprise.js';
    this.captchaEndpoint = 'validateCaptcha';
    this.captchaKeyId = '6LfCWGEqAAAAADTDBq_SufeVfxFDmeuLoeFCbU6r';
    this.premiumAuctionBidThreshold = 500000;
    this.premiumAuctionBannerThreshold = 350000;
  }
}
